import { ItemCondition, LargeInstrumentWarehouseIssueType, PackageType, PackageTypeCondition } from '../../../../enums';

export interface ILargeInstrumentWarehouseSubtypeDom {
    issueType: LargeInstrumentWarehouseIssueType;
    potentialIssueNoted: boolean;
    claimFiled: boolean;
    packageType: PackageType;
    packageTypeCondition: PackageTypeCondition;
    conditionOfItem: ItemCondition[];
    additionalPackagingInfo?: string;
}
